import React from 'react';
import PropTypes from 'prop-types';

import { ContainerLoadingIndicator } from '@tfecom-thermofisher/react-komodo-design';

const Loading = ({ isLoading }) => (
  <ContainerLoadingIndicator
    isLoading={isLoading}
    data-testid="qa-loading-indicator"
  />
);

Loading.propTypes = {
  isLoading: PropTypes.bool
};

export default Loading;
